import axios, { AxiosResponse } from 'axios' 
import { IRentalTermsModel } from './RentalTermModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const RENTALTERM_CREATE_URL = `${API_URL}api/v1/definition/rentalTerms/create`
export const RENTALTERM_GET_ALL_URL = `${API_URL}api/v1/definition/rentalTerms/all`
export const RENTALTERM_DELETE_URL = `${API_URL}api/v1/definition/rentalTerms/delete/`
export const RENTALTERM_UPDATE_URL = `${API_URL}api/v1/definition/rentalTerms/update/`

export function createRentalTerm(rentalTerm: IRentalTermsModel) {
  return axios.post(RENTALTERM_CREATE_URL, rentalTerm)
}

export async function loadRentalTerms(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IRentalTermsModel>>>> {
  return axios.get(RENTALTERM_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteRentalTerm(rentalTermId: String) {
  return axios.delete(RENTALTERM_DELETE_URL + rentalTermId)
}

export function updateRentalTerm(rentalTerm: IRentalTermsModel) {
  return axios.patch(RENTALTERM_UPDATE_URL + rentalTerm.id, rentalTerm)
}
